import { GETGROUPMEMBER_SUCCESS, GETGROUPMEMBER_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const getGroupMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETGROUPMEMBER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETGROUPMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getGroupMemberReducer;
